module.exports = __webpack_public_path__ + "static/media/icon_eyeDrop.d4730aaf.svg";